import { RendererProvider } from '@fluentui/react-components';
import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import { useNoopGriffelRenderer } from './hooks';

const GriffelNoopRendererProvider: FC<PropsWithChildren> = ({ children }) => {
  const noopRendererToPreventRuntimeStyleInjection = useNoopGriffelRenderer();
  const isProduction = process.env.NODE_ENV === 'production';

  if (!isProduction) {
    return <>{children}</>;
  }

  return <RendererProvider renderer={noopRendererToPreventRuntimeStyleInjection}>{children}</RendererProvider>;
};

export default GriffelNoopRendererProvider;
